import {
  type AssemblyCurrency,
  AssemblyCurrencyType,
  mapHexCodeToEmoticon,
} from '@assembly-web/services';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { TextField } from '../../../../../DesignSystem/Inputs/TextField';
import { messages } from '../message';

export function Details({ currency }: { currency?: AssemblyCurrency }) {
  const { formatMessage } = useIntl();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const pointsWatch = watch('points');
  const currencyIcon = currency ? (
    currency.type === AssemblyCurrencyType.Custom ? (
      <img
        alt={currency.name}
        className="mr-0.5 h-3 w-3"
        src={currency.value}
      />
    ) : (
      mapHexCodeToEmoticon(currency.value)
    )
  ) : (
    ''
  );

  const inputFields = [
    {
      id: 'title',
      type: 'text',
      title: formatMessage(messages.titleLabel),
      placeholder: formatMessage(messages.placeholderLabelForTitle),
      hintLabel: formatMessage(messages.titleHintLabel),
    },
    {
      id: 'description',
      type: 'text',
      title: formatMessage(messages.descriptionLabel),
      placeholder: formatMessage(messages.placeholderLabelForDescription),
      hintLabel: formatMessage(messages.descriptionHintLabel),
    },
    {
      id: 'points',
      type: 'number',
      title: formatMessage(messages.currencyTitle, {
        currency: currency?.pluralName,
      }),
      placeholder: formatMessage(messages.placeHolderForCurrency, {
        currencyIcon: currencyIcon as string,
      }),
    },
  ];
  const inputClassName = 'mt-1 placeholder:text-gray-8 text-sm';
  const labelClassName = 'text-sm font-medium';

  return (
    <div>
      <div className="flex flex-col gap-4">
        {inputFields.map((item, index) => {
          const error = errors[item.id]?.message as string;
          return (
            <div key={index}>
              <TextField
                className="pointer-events-auto"
                {...register(item.id)}
                type={item.type}
                placeholder={item.placeholder}
                invalidText={error}
                label={item.title}
                isInvalid={Boolean(error)}
                inputClassName={inputClassName}
                labelClassName={labelClassName}
                connectedLeft={
                  item.id === 'points' && Boolean(pointsWatch) && currencyIcon
                }
                aria-label={item.id}
                helpText={item.hintLabel}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
